import { Modal } from "antd";
import LicenseIcon from "../../../assets/images/vectors/SideBarIcons/LicenseIcon";
import { LicenseItemForm } from "./LicenseItemForm";
import { LicenseItemPicker } from "./LicenseItemPicker";

const LicenseItemModal = ({
  open,
  setOpen,
  licenseId,
  editingItem,
  existingItems,
  setEditingItem,
  itemsRefetch,
}) => {
  const isEdit = editingItem?.ItemNo != null;

  const handleClose = () => setOpen(false);

  return (
    <Modal
      open={open}
      closable={false}
      onCancel={handleClose}
      // Clearing editingItem mid close-animation would switch to add mode (width/content) while fading out.
      afterClose={() => setEditingItem(null)}
      footer={null}
      width={isEdit ? 580 : 1200}
      centered
      destroyOnClose
      title={
        <div className="flex items-center bg-gray-200 p-2 rounded-md">
          <LicenseIcon className="text-[18px] text-black " />
          <span className="text-[14px] font-['Poppins'] text-black  ml-2">
            {isEdit ? "Edit license item" : "Add license item"}
          </span>
        </div>
      }
    >
      {licenseId ? (
        isEdit ? (
          <LicenseItemForm
            licenseId={licenseId}
            editingItem={editingItem}
            existingItems={existingItems}
            onCancel={handleClose}
            onSaved={itemsRefetch}
          />
        ) : (
          <LicenseItemPicker
            licenseId={licenseId}
            existingItems={existingItems}
            onCancel={handleClose}
            onSaved={itemsRefetch}
          />
        )
      ) : null}
    </Modal>
  );
};

export default LicenseItemModal;
